import type {
  ElementLoadEvent,
  RecoClickEvent,
  RecoViewEvent,
} from "@cube/tracking-library-api";
import type {
  BestandteileTrackingData,
  BestandteilTrackingData,
} from "../../carousel/KombiModulCarousel";
import {
  executeOnOriginPage,
  isInBottomSheet,
} from "@mobile-app/native-dialog";

const pushToDatalayer = (
  data: RecoViewEvent | RecoClickEvent | ElementLoadEvent,
): void => {
  if (isInBottomSheet()) {
    const jsToExecute = `window.CubeDataLayer.push(${JSON.stringify(data)})`;
    executeOnOriginPage(jsToExecute);
  } else {
    window.CubeDataLayer?.push(data);
  }
};

/* eslint-disable camelcase, @typescript-eslint/naming-convention */
export const trackOutfitsImpression = (currency: string): void => {
  const recoViewEvent: RecoViewEvent = {
    event_name: "reco_view",
    responsible_team_tracking: "RECO",
    responsible_team_feature: "RECO",
    currency: {
      code: currency,
    },
    items: [],
    promotion_data: {
      name: "outfit_list",
      rule: "visuelle_aehnlichkeit",
      slot: "kombi-modul",
      placement: "page",
      type: "slider",
    },
    event_data: {
      is_interaction_event: false,
    },
  };
  pushToDatalayer(recoViewEvent);
};

export const trackBestandteileImpression = (
  headlineDE: string,
  currency: string,
  items: BestandteileTrackingData[],
): void => {
  const recoViewEvent: RecoViewEvent = {
    event_name: "reco_view",
    responsible_team_tracking: "RECO",
    responsible_team_feature: "RECO",
    currency: {
      code: currency,
    },
    items: items.map((item) => ({
      item_type: "Product",
      is_sponsored: false,
      target_url: item.targetUrl,
      position: item.position + 1,
      syan: item.syan,
      farb_id: item.farbId,
    })),
    promotion_data: {
      name: "outfit",
      rule: headlineDE,
      slot: "kombi-modul",
      placement: "layer",
      type: "slider",
    },
    event_data: {
      is_interaction_event: false,
    },
  };
  pushToDatalayer(recoViewEvent);
};

export const trackOutfitClick = (index: number, currency: string): void => {
  const recoClickEvent: RecoClickEvent = {
    event_name: "reco_click",
    responsible_team_tracking: "RECO",
    responsible_team_feature: "RECO",
    currency: {
      code: currency,
    },
    items: [],
    promotion_data: {
      placement: "page",
      name: "outfit_list",
      slot: "kombi-modul",
      type: "slider",
      rule: "",
    },
    event_data: {
      is_interaction_event: true,
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      position: index + 1,
    },
  };
  pushToDatalayer(recoClickEvent);
};

export const trackBestandteilClick = (
  bestandteil: BestandteilTrackingData,
  currency: string,
): void => {
  const recoClickEvent: RecoClickEvent = {
    event_name: "reco_click",
    responsible_team_tracking: "RECO",
    responsible_team_feature: "RECO",
    currency: {
      code: currency,
    },
    items: [
      {
        target_url: bestandteil.targetUrl,
        item_type: "Product",
        syan: bestandteil.syan,
        position: bestandteil.index + 1,
        is_sponsored: false,
        farb_id: bestandteil.farbId,
      },
    ],
    promotion_data: {
      placement: "layer",
      name: "outfit",
      slot: "kombi-modul",
      type: "slider",
      rule: bestandteil.headlineDE,
    },
    event_data: {
      is_interaction_event: true,
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      position: bestandteil.index + 1,
    },
  };
  pushToDatalayer(recoClickEvent);
};

window.CubeDataLayer ??= [];
